// store.js
import Vue from 'vue';
import Vuex from 'vuex';
import * as getters from './getters';
import * as actions from './actions';
import * as mutations from './mutations';
import { version, name } from '../../package.json';

Vue.use(Vuex);
const projectVersion = version.replace(/\./gi, '-');
const projectFolder = `/media/landing-collections/${name}-${projectVersion}/`;
function getBasePath() {
  let basePath = '';
  if (!window.location.origin) {
    window.location.origin = `${window.location.protocol}//${window.location.hostname}${window.location.port ? `:${window.location.port}` : ''}`;
  }
  if (window.location.origin.indexOf('paris') > -1) {
    basePath = `${window.location.origin}${projectFolder}`;
  }
  return basePath;
}
export function createStore() { // eslint-disable-line
  return new Vuex.Store({
    state: {
      init: false,
      mode: 'test', // used to render links for products
      projectFolder,
      basePath: getBasePath(),
      isIE: !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g),
      config: {},
      scroll: {
        active: false,
        offset: 0,
        index: 0,
      },
      isMobile: true,
    },
    getters,
    actions,
    mutations,
  });
}
